export default __webpack_public_path__ + "assets/images/b5f850e6caa66fa818a6ce55dd92fd36.svg";